import { Outlet, Navigate } from "react-router-dom";

const PublicLayout = () => {
  const storedToken = localStorage.getItem("token");

  if (storedToken) {
    return <Navigate to="/awbtrackedlist" />;
  }

  return <Outlet />;
};

export default PublicLayout;
